import { render } from "./TyreInfo.vue?vue&type=template&id=21a2c884&scoped=true"
import script from "./TyreInfo.vue?vue&type=script&lang=js"
export * from "./TyreInfo.vue?vue&type=script&lang=js"

import "./TyreInfo.vue?vue&type=style&index=0&id=21a2c884&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a2c884"]])

export default __exports__